import { Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";
import { numberFormatter } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	icon: LucideIcon;
	iconColor: string;
	label: string;
	amount: number;
	currencySign: string;
	amountColor?: string;
};

export const FinancialBalanceRow: FC<Props> = ({
	icon: Icon,
	iconColor,
	label,
	amount,
	currencySign,
	amountColor,
}) => {
	const theme = useTheme();

	return (
		<Stack direction="row" alignItems="center" justifyContent="space-between">
			<Stack direction="row" alignItems="center" gap={0.8}>
				<Icon size={theme.iconSize.sm} color={iconColor} />
				<Typography variant="body2" color="text.secondary">
					{label}
				</Typography>
			</Stack>
			<Typography variant="bodyStrong" color={amountColor} tabular>
				{numberFormatter.format(amount)}{" "}
				<Typography component="span" variant="caption" color="text.secondary">
					{currencySign}
				</Typography>
			</Typography>
		</Stack>
	);
};
